import home from './src/home.vue'
import MapAdmin from './src/MapAdmin.vue'
import MapAdminEdit from './src/MapAdminEdit.vue'
import UMap from './src/components/UMap.vue'
import IndexView from './src/IndexView.vue'
import VehicleSchedulingView from './src/VehicleSchedulingView.vue' //车船调度实时车辆监控
import VehicleTrackView from './src/VehicleTrackView.vue' //车船调度车辆轨迹查看
import MobileHotMapView from './src/MobileHotMap.vue' //手机热力图展示
import VehicleTrackViewNew from './src/VehicleTrackViewNew.vue'

let views = {
    home,
    MapAdmin,
    MapAdminEdit,
    UMap,
    IndexView,
    VehicleSchedulingView,
    VehicleTrackView,
    MobileHotMapView,
    VehicleTrackViewNew
};

export default views;